export type CategorySegmentAttachmentQuery = {
  categorySegment: {
    activeAttachments: IAttachment[]
  }
  lineItem: ILineItem
}

export default function attachmentNormalizer({
  categorySegment,
  lineItem
}: CategorySegmentAttachmentQuery) {
  const categorySegmentIds = lineItem.sub_items.map((subItem) => subItem?.categorySegmentId)
  return {
    categorySegment: {
      activeAttachments: categorySegment.activeAttachments.map((attachment) => ({
        ...attachment,
        hasAdded: categorySegmentIds.includes(attachment.categorySegment?.id)
      }))
    },
    lineItem
  }
}
